import React from 'react';
import ReactWordcloud from 'react-wordcloud';

const GenreChart = props => {
  if (props.artists.length === 0) return null;
  const genreList = {};
  props.artists.forEach(artist => {
    artist.genres.forEach(genre => {
      if (genreList[genre]) {
        genreList[genre] += 1;
      } else {
        genreList[genre] = 1;
      }
    });
  });
  const words = [];
  for (let genre in genreList) {
    words.push({
      text: genre,
      value: genreList[genre]
    });
  }
  return (
    <div
      className="sticky-top"
      style={{ backgroundColor: '#FFFFFF', height: '500px', width: '100%' }}
    >
      <ReactWordcloud
        options={{
          rotations: 0,
          padding: 0,
          spiral: 'archimedean',
          rotationAngles: [0, 90],
          fontSizes: [15, 70]
        }}
        words={words}
      />
    </div>
  );
};

export default GenreChart;
